import { useMemo } from 'react';
import { OctoOrder } from '@repo/types';

export default function useActiveOctoBookings(octoOrder?: OctoOrder) {
    return useMemo(() => {
        if (!octoOrder) return [];
        return octoOrder.bookings.filter(
            (booking) => booking.status !== 'CANCELLED' && booking.status !== 'EXPIRED',
        );
    }, [octoOrder]);
}
